import { axiosBaseQuery } from "@/shared/api/base-query";
import { gatewayApiInstance } from "@/shared/api/axios";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  StaffMeResponse,
  StaffStoreAppDetailsResponse,
  StaffStoreAppDetailsVariables,
  StaffStoreAppsResponse,
  StaffStoreDetailsResponse,
  StaffStoreDetailsVariables,
  StaffStoresResponse,
  StaffStoresVariables,
  AnnotatorsResponse,
} from "../types";

const baseQuery = axiosBaseQuery(gatewayApiInstance);

export const gatewayApi = createApi({
  reducerPath: "gatewayApi",
  baseQuery,
  endpoints: (builder) => ({
    login: builder.mutation<any, { username: string; password: string }>({
      query: ({ username, password }) => ({
        url: `/gateway/staff/login`,
        method: "POST",
        data: {
          username,
          password,
        },
      }),
    }),
    logout: builder.mutation<any, void>({
      query: () => ({
        url: `/gateway/auth/logout`,
        method: "POST",
      }),
    }),
    staffMe: builder.query<StaffMeResponse, void>({
      query: () => ({
        url: `/gateway/staff/me`,
        method: "GET",
      }),
    }),
    staffStores: builder.query<
      StaffStoresResponse,
      StaffStoresVariables | undefined
    >({
      query: (params = {}) => ({
        url: `/gateway/staff/stores`,
        params,
        method: "GET",
      }),
    }),
    staffStoreDetails: builder.query<
      StaffStoreDetailsResponse,
      StaffStoreDetailsVariables
    >({
      query: (params) => ({
        url: `/gateway/staff/stores/${params.storeKey}`,
        method: "GET",
      }),
    }),
    staffStoreApps: builder.query<
      StaffStoreAppsResponse,
      StaffStoreDetailsVariables
    >({
      query: (params) => ({
        url: `/gateway/staff/stores/${params.storeKey}/apps`,
        method: "GET",
      }),
    }),
    staffStoreAppDetails: builder.query<
      StaffStoreAppDetailsResponse,
      StaffStoreAppDetailsVariables
    >({
      query: (params) => ({
        url: `/gateway/staff/stores/${params.storeKey}/apps/${params.appKey}`,
        method: "GET",
      }),
    }),
    staffAnnotators: builder.query<AnnotatorsResponse, void>({
      query: () => ({
        url: `/gateway/staff/annotators`,
        method: "GET",
        params: {
          page_size: 100,
        },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useStaffMeQuery,
  useStaffStoresQuery,
  useStaffStoreDetailsQuery,
  useLazyStaffStoreAppDetailsQuery,
  useLazyStaffStoreAppsQuery,
  useStaffAnnotatorsQuery,
  useLazyStaffAnnotatorsQuery,
} = gatewayApi;
